import React from 'react';
import { PhotoPlaceholder } from './Placeholders';
interface ProcesoItem {
  images: {
    src: string;
    alt: string;
  }[];
  title: string;
  text: string;
  placeholderText?: string;
}
const ITEMS: ProcesoItem[] = [{
  images: [{
    src: 'https://cdn.magicpatterns.com/uploads/b6wUMEzH9HXcxHnmzo5d6j/imagen_03_-_HILOS_TENIDOS_P3.png',
    alt: 'Canasto con ovillos de hilos teñidos en colores naturales'
  }],
  title: 'Fibras Naturales',
  text: 'Trabajamos con lana de llama, oveja y vicuña. Cien por ciento natural.'
}, {
  images: [{
    src: 'https://cdn.magicpatterns.com/uploads/pnrg45f9drxwFD6J3AQgjG/imagen_02_-_TENIDO_HILOS_P3.png',
    alt: 'Hilos de lana siendo teñidos en una olla con tintes naturales'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/teV3pgQhJJGgv4nAvZghos/imagen_01_-_COLORES_NATURALES_P3.png',
    alt: 'Campo de flores usadas como colorante natural en la Quebrada de Humahuaca'
  }],
  title: 'Tintes Naturales',
  text: 'Colores extraídos de plantas y minerales de la Quebrada como cebolla y molle.'
}, {
  images: [{
    src: 'https://cdn.magicpatterns.com/uploads/18wjs7rTvBEp5iXezKPhQ5/Telar.png',
    alt: 'Telar tradicional con hilos tensados durante el proceso de tejido'
  }],
  title: 'Telar Artesanal',
  text: 'Cada pieza tejida a mano en telar tradicional en nuestro taller de Purmamarca.'
}];
export function Proceso() {
  return <section id="proceso" className="tex-marron py-12 md:py-24 px-6 md:px-12" data-id="element-102">
      <div className="max-w-7xl mx-auto" data-id="element-103">
        <h2 className="font-labrada font-bold text-4xl md:text-5xl text-crema mb-10 md:mb-16 text-center" data-id="element-104">
          Así lo hacemos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12 md:mb-20" data-id="element-105">
          {ITEMS.map(item => <div key={item.title} className="flex flex-col items-center text-center" data-id="element-106">
              {/* Thread-style frame: outer ring + inner border evokes woven seam */}
              <div className="w-full aspect-square mb-6 p-1.5 rounded-md border border-dashed border-crema/40 ring-1 ring-crema/15 ring-offset-2 ring-offset-marron overflow-hidden" data-id="element-107">
                {item.images.length === 0 ? <PhotoPlaceholder text={item.placeholderText ?? 'FOTO'} className="w-full h-full rounded-sm" data-id="element-108" /> : item.images.length === 1 ? <img src={item.images[0].src} alt={item.images[0].alt} className="w-full h-full object-cover rounded-sm" data-id="element-109" /> : <div className="w-full h-full grid grid-cols-2 gap-1 rounded-sm overflow-hidden" data-id="element-110">
                    {item.images.map((img, i) => <img key={i} src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-111" />)}
                  </div>}
              </div>
              <h3 className="font-labrada font-bold text-xl text-crema mb-3" data-id="element-112">
                {item.title}
              </h3>
              <p className="font-labrada text-crema/85 text-lg leading-relaxed" data-id="element-113">
                {item.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}